<script setup lang="ts">
import { computed, toRefs } from 'vue'

defineEmits<{
  (e: 'dblclick', event: MouseEvent): void
}>()

const props = withDefaults(
  defineProps<{
    question: string
    darkMode?: boolean | 'auto'
    displayMode?: 'expanded' | 'default' | 'slideshow'
    xOverlay?: boolean
    isStream?: boolean
  }>(),
  { darkMode: 'auto', displayMode: 'default', xOverlay: false, isStream: false },
)

const { darkMode, xOverlay, question, isStream } = toRefs(props)
const isDisplayModeExpanded = computed(() => props.displayMode === 'expanded')
const isDisplayModeSlideshow = computed(() => props.displayMode === 'slideshow')
const isDisplayModeExpandedOrSlideshow = computed(() => isDisplayModeExpanded.value || isDisplayModeSlideshow.value)
</script>
<template>
  <div
    :class="[
      'pt-3 break-word-anywhere',
      isStream ? 'px-4' : 'px-3',
      isDisplayModeExpandedOrSlideshow
        ? {
            'pb-3 text-heading-2 text-center font-semibold': true,
            'text-dark-text-100': darkMode === false,
            'text-light-text-100': darkMode === true,
            'text-dark-text-100 dark:text-light-text-100': darkMode === 'auto',
          }
        : {
            'pb-2': true,
            'max-w-[calc(100%-28px)]': !xOverlay, // 28px is width of more button with slope
            'text-body': isStream,
            'text-body-small': !isStream,
            'text-dark-text-200': darkMode === false,
            'text-light-text-200': darkMode === true,
            'text-dark-text-200 dark:text-light-text-200': darkMode === 'auto',
          },
    ]"
    data-testid="surfacePostPollQuestion"
    @dblclick="$emit('dblclick', $event)"
  >
    {{ question }}
  </div>
</template>
